<template>
  <div>
    <v-layout row wrap pt-1>
      <v-flex xs12>
        <v-layout row wrap pt-1 pb-0>
          <v-flex class="bold-font ypo_blue_color list-frame__title"
                  :data-qe-id="`${currentRibbon.key}_label`">
            {{currentRibbon.label}}
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex pr-3>
            <community-ribbon-action-buttons :current-ribbon="currentRibbon"
                                   :handle-cancel="cancel"
                                   :is-disabled="noFilterData"
                                   :newly-selected-filter-number="newlySelectedFilterNumber"
                                   :handle-apply="apply">
            </community-ribbon-action-buttons>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout row wrap class="filter-options__filters" mt-3>
      <v-flex xs12 sm6 md4 lg3 pa-1 pr-2 v-for="(filter, index) in ribbonItemFromApi.filters"
              v-if="showRibbonCheckboxOption(filter)"
              :key="getRandomId(index)">
        <label class="check-container ypo_blue_color">
          <v-layout :class="isPreviouslySelected(filter, localFilterState) ? 'bold-font' : ''">
            <v-flex class="check-container--label"
                    :data-qe-id="`${currentRibbon.key}_filter-${index}_label`">
              {{filter.label}}
            </v-flex>
            <v-flex class="check-container--count"
                    :data-qe-id="`${currentRibbon.key}_filter-${index}_count`"
                    v-if="labelWithCount(filter, currentRibbon.key)">
              {{labelWithCount(filter, currentRibbon.key)}}
            </v-flex>
          </v-layout>
          <input type="checkbox"
                 :value="filter"
                 :data-qe-id="`${currentRibbon.key}_filter-${index}_checkbox`"
                 v-model="localFilterState">
          <span class="checkmark"></span>
        </label>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex';
  import { storeAction } from "../../store/storeActions.constant";
  import { storeMutation } from "../../store/storeMutations.constant";
  import { appCommonConstants } from "../appCommon.constants";
  import { getRandomId } from "../../common/utils/utils";
  import { storeGetters } from "../../store/storeGetters.constant";
  import { isButtonEnabled, setLocalFilterData } from "@/components/EventDirectoryPage/eventDirectoryPage.constants";
  import CommunityRibbonActionButtons from "./CommunityRibbonActionButtons";

  export default {
    name: "CommunityType",
    components: { CommunityRibbonActionButtons },
    created() {
      const filtersFromRoute = this.$route.query.communityFilters ? JSON.parse(this.$route.query.communityFilters) : null;
      if (filtersFromRoute && this.currentRibbon) {
        this.localFilterState = setLocalFilterData(filtersFromRoute[this.currentRibbon.key], this.ribbonItemFromApi);
      }
    },
    data() {
      return {
        appCommonConstants,
        localFilterState: [],
      };
    },
    props: {
      currentRibbon: {
        type: Object,
        required: true,
      },
      postAction: {
        type: Function,
        required: true,
      },
      ribbonItemFromApi: {
        type: Object,
        required: true,
      },
      isPreviouslySelected: {
        type: Function,
        required: true,
      },
      labelWithCount: {
        type: Function,
        required: true,
      },
      showRibbonCheckboxOption: {
        type: Function,
        required: true,
      },
      updateRoute: {
        type: Function,
        required: true,
      },
      applyNumberCount: {
        type: Function,
        required: true,
      },
    },
    methods: {
      ...mapActions({
        getCommunityDirectoryResults: `communityDirectory/${storeAction.getCommunityDirectoryResults}`,
      }),
      ...mapMutations({
        setCommunityStateFromRouter: `communityDirectory/${storeMutation.setCommunityStateFromRouter}`,
      }),
      getRandomId,
      cancel() {
        this.postAction();
      },
      apply() {
        this.updateRoute(this.currentRibbon.key, this.localFilterState);
        this.getCommunityDirectoryResults();
        this.postAction();
      },
      noFilterData() {
        return isButtonEnabled(this.communitySelectedFilters[this.currentRibbon.key], this.localFilterState);
      },
    },
    computed: {
      ...mapGetters({
        communitySelectedFilters: `communityDirectory/${storeGetters.communitySelectedFilters}`,
      }),
      newlySelectedFilterNumber() {
        return this.applyNumberCount(this.localFilterState);
      },
      previouslySelected() {
        return this.communitySelectedFilters && this.currentRibbon ? this.communitySelectedFilters[this.currentRibbon.key] : [];
      },
    },
  };
</script>


<style lang="scss" scoped>
  @import '../../common/styles/_colors.scss';
  @import '../../common/styles/_commonClasses.scss';

  .list-frame {
    &__title {
      padding-left: 20px;
      margin-top: 13px;
      text-align: left;
    }

    &__actions {
      padding-right: 13px;
    }
  }
  .filter-options {
    background-color: $ypo-extra-light-gray;
    @extend %ypo_checkbox;

    &__filters {
      background-color: $white;
      padding: 20px 40px 15px;
      margin: 5px 20px 20px;
    }

    &__typeAhead {
      margin-top: 20px;

      &-input {
        background-color: $white;
      }

      &-result {
        background-color: $white;
        border: 1px solid $ypo-tile-border;
        padding: 10px;
        border-top: none;
        width: 98%;
        margin-left: 1%;
        min-height: 60px !important;
        position: relative;
        max-height: 220px !important;
        overflow: auto;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5);

        &--item {
          max-height: 40px !important;
        }
      }

      &-previous {
        background-color: $white;
        border: 1px solid $ypo-tile-border;
        padding-left: 10px;
      }
    }

    &__subFilters {

      &-options {
        background-color: $white;
        padding: 20px 40px;
      }
    }

    &__sub-label {
      color: $ypo-blue;
      font-family: "Noto Sans", sans-serif;
      font-size: 14px;
      font-weight: bold;
      letter-spacing: 0.23px;
      line-height: 24px;
    }

    .private_networks {
      font-size: 16px;
      letter-spacing: -0.01px;
      line-height: 22px;
    }

    .blocked-filter {
      position: absolute;
      height: 100%;
      width: 100%;
      z-index: 2;
      left: -1px;
      background-color: transparent;
    }

    .checked-box {
      &:after{
        display: block;
        left: 5px;
        top: 1px;
        width: 5px;
        height: 12px;
        border: solid #44779f;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg)
      }
    }
  }

</style>

